import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";

const BusinessSLA = () => {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant="link" className="h-auto p-0 text-primary-500 underline hover:text-primary-600">
          Seller Service Agreement
        </Button>
      </DialogTrigger>
      <DialogContent className="max-h-[80vh] overflow-y-auto max-w-4xl bg-white">
        <DialogHeader className="border-b border-gray-200 pb-4">
          <DialogTitle className="text-2xl text-center font-bold text-gray-800">
            Busiconn Seller Service Level Agreement
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-6 text-gray-700 px-4 py-6">
          <section className="space-y-3">
            <h2 className="font-bold text-lg text-gray-800">1. Purpose</h2>
            <p className="leading-relaxed">
              This SLA outlines Busiconn's commitments to sellers regarding platform performance, transaction handling, and dispute resolution for all commercial activities conducted through our marketplace.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="font-bold text-lg text-gray-800">2. Service Commitments</h2>
            <ul className="list-disc pl-5 space-y-2 leading-relaxed">
              <li><strong className="text-gray-800">Uptime Guarantee:</strong> 99.5% monthly availability for core selling features (product listings, live streaming, deal tracking)</li>
              <li><strong className="text-gray-800">Payment Processing:</strong> Instant payment capture with funds held in escrow until delivery confirmation</li>
              <li><strong className="text-gray-800">Transaction Support:</strong> Dedicated seller support team available during business hours</li>
            </ul>
          </section>

          <section className="space-y-3">
            <h2 className="font-bold text-lg text-gray-800">3. Performance Standards</h2>
            <ul className="list-disc pl-5 space-y-2 leading-relaxed">
              <li><strong className="text-gray-800">Live Streaming:</strong> HD video streaming with ≤2s latency for 95% of broadcasts</li>
              <li><strong className="text-gray-800">Deal Processing:</strong> 1:1 chat messages delivered within 1s for 99% of messages</li>
              <li><strong className="text-gray-800">Dispute Resolution:</strong> Initial response within 48 hours for all transaction disputes</li>
            </ul>
          </section>

          <section className="space-y-3">
            <h2 className="font-bold text-lg text-gray-800">4. Transaction Protection</h2>
            <ul className="list-disc pl-5 space-y-2 leading-relaxed">
              <li>Secure escrow service for all transactions</li>
              <li>Fraud detection system for buyer/seller protection</li>
              <li>Clear dispute resolution process with evidence collection</li>
            </ul>
          </section>

          <section className="space-y-3">
            <h2 className="font-bold text-lg text-gray-800">5. Compensation Policy</h2>
            <p className="leading-relaxed">
              In case of failure to meet SLA commitments, eligible sellers may receive service credits proportional to the downtime, not exceeding one month's platform fees.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="font-bold text-lg text-gray-800">6. Seller Conduct Rules</h2>
            <ul className="list-disc pl-5 space-y-2 leading-relaxed">
              <li>Sellers must not share personal contact details (e.g., phone numbers, WhatsApp, email, social media) in live chat or product descriptions.</li>
              <li>All transactions must be completed through the Busiconn platform to maintain escrow protection and trust.</li>
              <li>Sellers who repeatedly attempt off-platform deals may face temporary or permanent suspension.</li>
              <li>Content shared in live sessions must comply with community guidelines and avoid misleading pricing or product claims.</li>
              <li>“Trusted Seller” badges will be awarded to sellers who maintain:
                <ul className="list-disc pl-5 space-y-1">
                  <li>10+ successful escrow transactions</li>
                  <li>95% delivery confirmation rate</li>
                  <li>No contact leaks or violations</li>
                </ul>
              </li>
            </ul>
          </section>

          <section className="pt-4 border-t border-gray-200">
            <p className="text-sm text-gray-600">
              Effective: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>
          </section>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default BusinessSLA;
